const PERSISTED_FIELDS = [
  'location_name',
  'street1',
  'street2',
  'zip',
  'country',
  'state',
  'city',
  'contact_name',
  'email',
  'additional_email_list',
  'phone1',
  'phone2',
  'timezone',
  'rate_flow',
  'net_day_cutoff',
  'distance_unit',
  'currency',
  'days_in_month',
  'location_type',
  'lat_long_format',
  'latitude',
  'lat_deg',
  'lat_min',
  'lat_sec',
  'longitude',
  'long_deg',
  'long_min',
  'long_sec',
  'weekend_start_from',
  'no_of_days_in_weekend',
  'weekend_rates_to_be_shown',
  'length_of_week',
  'adv_booking',
];

const normalizedValue = (value) => {
  if (value === undefined || value === null) return null;
  if (Array.isArray(value)) return value.map(normalizedValue);
  if (typeof value === 'object') {
    return Object.keys(value)
      .sort()
      .reduce((result, key) => {
        result[key] = normalizedValue(value[key]);
        return result;
      }, {});
  }
  return value;
};

export function normalizeTimezone(value) {
  const timezoneValue = typeof value === 'string'
    ? value.trim()
    : String(value?.value || '').trim();
  if (!timezoneValue) return null;

  const timezoneLabel = typeof value === 'object'
    ? String(value?.label || timezoneValue).trim()
    : timezoneValue;
  return {
    ...(value && typeof value === 'object' ? value : {}),
    value: timezoneValue,
    label: timezoneLabel || timezoneValue,
  };
}

// react-timezone-select cannot render null; use its supported empty-string
// value for legacy records that do not yet have a timezone.
export function timezoneSelectValue(value) {
  return normalizeTimezone(value) || '';
}

export function normalizeAdditionalEmailList(value) {
  const entries = Array.isArray(value)
    ? value
    : (typeof value === 'string' ? value.split(',') : []);

  return entries
    .map((entry) => String(entry ?? '').trim())
    .filter(Boolean);
}

export function buildLocationOptions(locations) {
  if (!Array.isArray(locations)) return [];
  return locations
    .filter((location) => location?.location_id !== undefined && location?.location_id !== null)
    .map((location) => {
      const id = String(location.location_id);
      const code = String(location.location_code || id).trim();
      return {
        value: id,
        label: `${location.location_name} (${code})`,
      };
    });
}

export function findLocationById(locations, selectedLocationId) {
  const id = String(selectedLocationId || '').trim();
  if (!id || !Array.isArray(locations)) return null;
  return locations.find((location) => String(location?.location_id) === id) || null;
}

export function isExactLocationSaveSuccess(responseBody) {
  return responseBody === 'success';
}

export function persistedLocationMatches(payload, responseBody) {
  const item = responseBody?.item;
  if (!payload || !item) return false;

  if (String(item.account_id) !== String(payload.account_id)) return false;
  if (String(item._id) !== String(payload.location_id)) return false;

  return PERSISTED_FIELDS.every((field) => {
    // The backend enriches legacy timezone values with the current UTC offset
    // required by reservation/service flows. The timezone ID is the stable
    // part of this field's persistence contract.
    if (field === 'timezone') {
      return normalizeTimezone(item[field])?.value
        === normalizeTimezone(payload[field])?.value;
    }

    return JSON.stringify(normalizedValue(item[field]))
      === JSON.stringify(normalizedValue(payload[field]));
  });
}
